// components/ProtectedRoute.jsx
import { Navigate, useLocation } from "react-router-dom";
import { toast } from "react-hot-toast";
import { useAuth } from "./AuthContext";
import { useEffect, useRef } from "react";

const normalizeRole = (role) => {
  const lowered = (role || "").toLowerCase();
  if (["customer_support", "customer_lead", "calling_team_lead"].includes(lowered)) {
    return "support";
  }
  return lowered;
};

// `exactRoles` matches the raw login role (no support-group merging)
const ProtectedRoute = ({ children, roles = [], exactRoles = [] }) => {
  const { isAuthenticated, role } = useAuth();
  const location = useLocation();
  const hasShownToast = useRef(false);

  useEffect(() => {
    if (!isAuthenticated && !hasShownToast.current) {
      toast.error("Please login first to access this page.");
      hasShownToast.current = true;
    }
  }, [isAuthenticated]);

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (Array.isArray(exactRoles) && exactRoles.length > 0) {
    const rawRole = (role || "").toLowerCase();
    if (!exactRoles.map((r) => r.toLowerCase()).includes(rawRole)) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  if (Array.isArray(roles) && roles.length > 0) {
    const currentRole = normalizeRole(role);
    const allowed = roles.map(normalizeRole);
    if (!allowed.includes(currentRole)) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
